// components/shared/CategoryNavBar.js
// Barra di navigazione categorie condivisa — stesso linguaggio visivo del Preventivatore.
// Presentational puro: riceve categorie, categoria attiva, callback di selezione e conteggi.

import React from 'react';
import { Card, CardContent } from '../ui/card';

const CategoryNavBar = ({ categories, activeCategory, onSelect, counts = {}, testIdPrefix = 'category-tab' }) => {
  return (
    <Card className="card-abitalo overflow-hidden">
      <CardContent className="p-0">
        {/* Desktop: barra tab elegante con scroll orizzontale (no wrap su due righe) */}
        <div className="hidden md:block bg-gradient-to-r from-[#FAFAFA] to-white">
          <div className="overflow-x-auto scrollbar-hide py-3 px-4">
            <div className="inline-flex bg-white rounded-xl shadow-sm border border-[#EAEAEA] p-1 mx-auto">
              {categories.map((cat) => {
                const count = counts[cat.code] || 0;
                const hasItems = count > 0;
                const isActive = activeCategory === cat.code;

                return (
                  <button
                    key={cat.code}
                    onClick={() => onSelect(cat.code)}
                    className={`relative whitespace-nowrap px-3 py-1.5 text-[13px] font-medium rounded-lg transition-all duration-200 ${
                      isActive
                        ? 'bg-gradient-to-r from-[#FF7819] to-[#FF9A4D] text-white shadow-md'
                        : hasItems
                          ? 'text-[#3C3C3C] hover:bg-[#FFF5EE]'
                          : 'text-[#AAAAAA] hover:text-[#666] hover:bg-gray-50'
                    }`}
                    data-testid={`${testIdPrefix}-${cat.code}`}
                  >
                    <span className={`font-semibold ${isActive ? 'text-white/75' : 'text-[#FF7819]'}`}>{cat.code}</span>
                    <span className="hidden xl:inline font-normal"><span className="mx-1 opacity-40">·</span>{cat.short || cat.label}</span>
                    {hasItems && (
                      <span className={`ml-1.5 text-xs px-1.5 py-0.5 rounded-full font-semibold ${
                        isActive ? 'bg-white/25 text-white' : 'bg-[#FF7819] text-white'
                      }`}>
                        {count}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Mobile: pills a scroll orizzontale touch */}
        <div className="md:hidden bg-gradient-to-b from-[#FAFAFA] to-white py-3">
          <div className="overflow-x-auto scrollbar-hide px-4">
            <div className="flex gap-2 min-w-max">
              {categories.map((cat) => {
                const count = counts[cat.code] || 0;
                const hasItems = count > 0;
                const isActive = activeCategory === cat.code;

                return (
                  <button
                    key={cat.code}
                    onClick={() => onSelect(cat.code)}
                    className={`flex-shrink-0 flex items-center gap-1.5 px-3.5 py-2 text-[13px] font-medium rounded-full transition-all duration-200 whitespace-nowrap border ${
                      isActive
                        ? 'bg-gradient-to-r from-[#FF7819] to-[#FF9A4D] text-white border-transparent shadow-lg shadow-orange-200'
                        : hasItems
                          ? 'bg-white text-[#3C3C3C] border-[#E5E5E5] hover:border-[#FF7819] hover:shadow-sm'
                          : 'bg-gray-50 text-[#AAAAAA] border-gray-200 hover:bg-white'
                    }`}
                    data-testid={`${testIdPrefix}-mobile-${cat.code}`}
                  >
                    <span className={`font-semibold ${isActive ? '' : 'text-[#FF7819]'}`}>{cat.code}</span>
                    <span className="font-normal">{cat.short || cat.label}</span>
                    {hasItems && (
                      <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${
                        isActive ? 'bg-white/25 text-white' : 'bg-[#FF7819]/10 text-[#FF7819]'
                      }`}>
                        {count}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CategoryNavBar;
